import { ErrorToast } from "../../../../../entities/toasts/Toasts";
import { ApiDefaultState } from "../../../api/ApiStore.State";
import { AppThunkAction } from "../../../ApplicationState";
import { ToastAction, ToastDispatchables } from "../../../toasts/Toasts.Actions";

export type CharacterAddCondition = { type: 'CHARACTER_ADD_CONDITION', characterId: string, conditionId: string }
export type CharacterRemoveCondition = { type: 'CHARACTER_REMOVE_CONDITION', characterId: string, conditionId: string }

export type CharacterConditionAction = CharacterAddCondition | CharacterRemoveCondition;

export const CharacterConditionActions = {
    addCondition: (characterId: string, conditionId: string): AppThunkAction<CharacterConditionAction | ToastAction> =>
        async (dispatch, getState) => {
            const conditions = getState().library.conditions;
            const condition = conditions.find(c => c.id == conditionId);

            const undo = () => {
                dispatch({ type: 'CHARACTER_REMOVE_CONDITION', characterId, conditionId });
                ToastDispatchables.toastLegacy(new ErrorToast(`Error adding ${condition?.name ?? "unknown condition"}.`), dispatch);
            }

            dispatch({ type: 'CHARACTER_ADD_CONDITION', characterId, conditionId });

            try {
                const response = await ApiDefaultState.characters.addCondition(characterId, conditionId);
                if (response.status == 'Error') {
                    undo();
                    ToastDispatchables.toastValidationResults(response.validationResults, dispatch);
                }
            }
            catch (e) {
                undo();
                console.error(e);
            }
        },

    removeCondition: (characterId: string, conditionId: string): AppThunkAction<CharacterConditionAction | ToastAction> =>
        async (dispatch, getState) => {
            const conditions = getState().library.conditions;
            const condition = conditions.find(c => c.id == conditionId);
            const undo = () => {
                dispatch({ type: 'CHARACTER_ADD_CONDITION', characterId, conditionId });
                ToastDispatchables.toastLegacy(new ErrorToast(`Error removing ${condition?.name ?? "unknown condition"}.`), dispatch);
            }
            dispatch({ type: 'CHARACTER_REMOVE_CONDITION', characterId, conditionId });

            try {
                const response = await ApiDefaultState.characters.removeCondition(characterId, conditionId);
                if (response.status == 'Error') {
                    undo();
                    ToastDispatchables.toastValidationResults(response.validationResults, dispatch);
                }
            }
            catch (e) {
                undo();
                console.error(e);
            }
        }
}